<template>
  <div class="order-list" v-if="orderList.length">
    <div class="order-item" v-for="(item, index) in orderList" :key="index" @click="goDetail(item.id)">
      <div class="order-header">
        <div class="order-title">
          <div class="order-img">
            {{ item.orderType === "D" ? "押金订单" : "充值订单" }}
          </div>
          <img class="right-img" :src="require('@/assets/arrow_right.png')"/>
        </div>
        <div class="order_yc">
          <img v-if="item.orderStatus==4" class="order_yc_img" src="@/assets/order-yic-img.png"/>
          <span class="order-status-text" :class="item.orderStatus == 1?'text-wan':item.orderStatus == 2?'text-tking':item.orderStatus == 3?'text-tksuccess':item.orderStatus == 4?'text-tkyc':'text-tksb'">{{
            getPayStatusText(item.orderStatus)
          }}</span>
        </div>
        
      </div>

      <div class="order-content">
        <div class="product-name">
          <img class="product-img" :src="item.picUrl" />
          <div class="product-info">
            <span class="product-info-text">{{
              item.orderType === "D" ? item.modelName:item.trafficPackageInfo.name?item.trafficPackageInfo.name:""
            }}</span>
            <span class="product-info-text2">{{
              item.orderType === "D" ? item.sn:item.trafficPackageInfo.packageDesc?item.trafficPackageInfo.packageDesc:""
            }}</span>
          </div>
        </div>
        <div class="price-section">
          <span class="price-label">¥{{ item.orderType === "D" ?item.amount : item.trafficPackageInfo.price?item.trafficPackageInfo.price:"" }}</span>
        </div>
      </div>

      <div class="order-price">
        <span class="price-label-bill">实付：</span>
        <span class="price-value-bill">¥{{ item.realAmount }}</span>
      </div>

      <div class="line"></div>

    </div>
  </div>

  <!-- 无数据时渲染空状态 -->
  <div v-else class="empty-container">
    <img class="empty-icon" src="@/assets/empty-order.png" />
    <div class="empty-text">暂无订单</div>
  </div>
</template>

<script>
import { getOrderList } from "@/api/user";

export default {
  data() {
    return {
      // Add your component data here
      id: "", //订单id
      orderStatus: "", //支付状态 1-已完成，2-退款处理中，3-退款成功，4-退款异常，5-退款失败
      amount: "", //订单金额
      payTime: "", //支付时间
      orderType: "", //订单类型
      picUrl: "", //图片地址
      count: "", //数量

      name: "", //套餐名称
      packageDesc: "", //套餐描述
      price: "", //套餐价格
      orderList: [],
    };
  },

  methods: {
    // Add your component methods here
    getPayStatusText(orderStatus) {
      // 改为方法处理状态
      return (
        {
          1: "已完成",
          2: "退款处理中",
          3: "退款成功",
          4: "退款异常",
          5: "退款失败",
        }[orderStatus] || "-"
      );
    },

    getDataList() {
      getOrderList()
        .then((res) => {
          console.log(res);
          this.orderList = res.list?res.list:[];
          console.log("获取列表成功", res);
        })
        .catch((err) => {
          console.error("获取列表失败：" + err);
        });
    },

    //跳转到订单详情页
    goDetail(id) {
      this.uni.navigateTo("/user/orderdetails?id=" + id);
    },
  },
  mounted() {
    // Add your mounted logic here
    this.getDataList();
  },
};
</script>

<style lang="less" scoped>
.empty-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  .empty-icon {
    width: 342px;
    height: 264px;
  }
  .empty-text {
    font-size: 30px;
    color: #848992;
    margin-top: 40px;
  }
}
.order-list {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: #f2f2f2;
  height: 100vh;
  overflow-y: auto;
}
.order-item {
  background: white;
  margin-bottom: 20px;
  .order-header {
    display: flex;
    justify-content: space-between;
    padding-left: 30px;
    padding-top: 32px;
    padding-right: 40px;
    .order-title {
      display: flex;
      align-items: center;
      .order-img {
        font-size: 30px;
        color: #000000;
      }
      .right-img{
        width: 30px;
        height: 30px;
      }
    }
    .order_yc{
      display: flex;
      flex-direction: row;
      align-items: center;
      .order_yc_img{
        width: 28px;
        height: 28px;
        margin-right: 4px;
      }
      .order-status-text {
        font-size: 26px;
      }
      .text-wan{
        color: #9D9D9D;
      }
      .text-tking{
        color: #FFB74C;
      }
      .text-tksuccess{
        color: #0FB176;
      }
      .text-tkyc{
        color: #FF3831;
      }
      .text-tksb{
        color: #FF3831;
      }
    }

  }
  
  .order-content {
    display: flex;
    justify-content: space-between;
    padding-left: 40px;
    padding-right: 40px;
    padding-top: 20px;
    .product-name {
      display: flex;
      flex-direction: row;
      margin-right: 30px;
    }
  }
  .product-img {
    width: 132px;
    height: 132px;
  }
  .product-info {
    margin-left: 16px;
    display: flex;
    flex-direction: column;
    .product-info-text {
      font-size: 30px;
      color: #000000;
    }
    .product-info-text2 {
      font-size: 26px;
      color: #848992;
      margin-top: 8px;
    }
  }
  .price-section {
    display: flex;
    flex-direction: column;
    .price-label {
      font-size: 30px;
      color: #000000;
    }
    .price-value {
      font-size: 26px;
      color: #848992;
      margin-top: 12px;
    }
  }
  .pay-time {
    font-size: 26px;
    color: #000000;
    margin-top: 20px;
  }
  .order-price {
    display: flex;
    justify-content: flex-end;
    padding-right: 40px;
    margin-top: 12px;
  }
  .price-label-bill {
    font-size: 30px;
    color: #000000;
  }
  .price-value-bill {
    font-size: 30px;
    color: var(--primary-color);
  }
  .line {
    background: #f1f1f1;
    height: 2px;
    margin-top: 28px;
    margin-left: 30px;
    margin-right: 30px;
  }
  .order-footer {
    justify-content: space-between;
    display: flex;
    align-items: center;
    padding-left: 40px;
    padding-right: 40px;
    .order-detail {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 148px;
      height: 56px;
      background: #ffffff;
      border-radius: 36px 36px 36px 36px;
      border: 2px solid #b5b8bd;
      margin-top: 20px;
      margin-bottom: 20px;
      .footer-text {
        font-size: 26px;
        color: #9b9da0;
      }
    }
  }
  .footer-time {
    font-size: 26px;
    color: #848992;
  }
}
</style>
